export type AgencySubscriptions = {
  expiresAt: string;
  startsAt: string;
  id: number;
  isLockedPeriod: boolean;
  maxSitesQuota: number | string;
  usedSitesQuota: number;
  name: string;
  status: string;
  type: AgencySubscriptionType;
};

export interface PaymentMethod {
  card: {
    expMonth: number;
    expYear: number;
    lastFour: string;
    type: string;
  };
  method: string;
  provider: string;
  providerPaymentMethodId: string;
  uwPaymentDataId: number;
}

export type AgencySiteData = {
  siteId: number;
  config: Record<string, string>;
};

export interface AgencySubscriptionSites {
  usedSitesQuota: number;
  sites: AgencySiteData[];
}

export enum AgencySubscriptionType {
  POST_PAID = 'POST_PAID',
  BULK_PREPAID = 'BULK_PREPAID',
}

export enum AgencySubscriptionStatus {
  ACTIVE = 'ACTIVE',
  NEW = 'NEW',
  DISABLED = 'DISABLED',
}
